import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import Card from 'components/Card';
import Check from 'components/SvgIcons/Check';
import Lock from 'components/SvgIcons/Lock';
import PrivacyDialog from 'components/PrivacyDialog';
import ProgressIndicator from 'components/ProgressIndicator';
import { useBooleanState } from 'core/hooks/useBooleanState';

const PathCard = ({
  closeAt,
  completedAt,
  completedEvents,
  contentCid,
  description,
  experienceToResume,
  isClosed,
  isCompleted,
  isLocked,
  openAt,
  shouldResume,
  showPrivacyPolicy,
  src,
  title,
  totalItems,
  uid,
}) => {
  const [dialogIsOpen, toggleDialogOpen] = useBooleanState(false);

  /*// firstmost open experience
  const nextExperience = experiences.find(
    (experience) =>
      itemStatus[experience.id] && !itemStatus[experience.id]?.completedAt,
  );

  const experienceStatus = itemStatus[nextExperience?.id];
  const experienceLocked = programLocked || experienceStatus?.locked;
  const experienceInProgress = experienceStatus?.completedItems?.length > 0;

  const programComplete = completedItems === totalItems;
  const programInProgress =
    (completedItems > 0 || experienceInProgress) &&
    !programClosed &&
    !programComplete;*/

  const subtitle = isCompleted ? (
    <FormattedMessage
      id="date.completed"
      values={{
        completedAt: moment.utc(completedAt).format('ll'),
      }}
    />
  ) : closeAt ? (
    `${moment.utc(openAt).format('ll')} - ${moment.utc(closeAt).format('ll')}`
  ) : (
    moment.utc(openAt).format('ll')
  );

  const actions = (
    <>
      <Button variant="outlined" component={Link} to={`/paths/${uid}`}>
        <FormattedMessage id="action.view" />
      </Button>
      <Button
        variant="contained"
        onClick={toggleDialogOpen}
        component={showPrivacyPolicy ? 'a' : Link}
        to={`/paths/${uid}/p/${contentCid}/e/${experienceToResume}`}
        disabled={isClosed || isCompleted || isLocked}
        startIcon={
          isCompleted ? <Check /> : isLocked || isClosed ? <Lock /> : null
        }
      >
        <FormattedMessage
          id={`action.${
            isCompleted
              ? 'complete'
              : isClosed
              ? 'closed'
              : shouldResume
              ? 'resume'
              : 'start'
          }`}
        />
      </Button>
      {dialogIsOpen && (
        <PrivacyDialog
          open
          onClose={toggleDialogOpen}
          maxWidth="md"
          link={`paths/${uid}/p/${contentCid}/e/${experienceToResume}`}
        />
      )}
    </>
  );

  const icon = !isClosed && (
    <ProgressIndicator total={totalItems} fraction={completedEvents} />
  );

  return (
    <Card
      title={title}
      subtitle={subtitle}
      content={description}
      image={src}
      icon={icon}
      actions={actions}
      disabled={isLocked}
    />
  );
};

PathCard.propTypes = {
  closeAt: PropTypes.string,
  completedAt: PropTypes.string,
  completedEvents: PropTypes.number,
  contentCid: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  experienceToResume: PropTypes.string,
  isClosed: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool,
  isLocked: PropTypes.bool.isRequired,
  openAt: PropTypes.string.isRequired,
  shouldResume: PropTypes.bool,
  showPrivacyPolicy: PropTypes.bool,
  src: PropTypes.string,
  title: PropTypes.string.isRequired,
  totalItems: PropTypes.number.isRequired,
  uid: PropTypes.string.isRequired,
};

PathCard.displayName = 'PathCard';
export default PathCard;
